module.exports = __webpack_public_path__ + "img/Logo.e84d92bf.svg";